export { default as UsersAdmin } from "./UsersAdmin";
export { default as usersAdminStore } from "./users_admin.store";



// WEBPACK FOOTER //
// ./src/modules/admin/modules/UsersAdmin/index.ts